<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text">  {{local_data.title}} {{local_data.element.structure}}  </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button" mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF"/>
      <path opacity="0.8" d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z" fill="#0080FF"/>
    </svg>
  </div>
  <mat-dialog-content>
    @if (formGroup1) {
      <form [formGroup]="formGroup1">
        <div class="dialog-box">
          <!-- <label class="mb-2 input-label">{{variables.cecoCodeName}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <input type="text" matInput formControlName="codeNameCtrl">
          </mat-form-field> -->
          <label class="mb-2 input-label">{{variables.costType}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <input type="text" matInput formControlName="costCenterCtrl">
          </mat-form-field>
          <div class="field-group" style="margin-bottom: 5px;">
            <label class="mb-2 input-label">0 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm0Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">3 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm3Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">6 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm6Ctrl">
            </mat-form-field>
          </div>
          <div class="field-group" style="margin-bottom: 5px;">
            <label class="mb-2 input-label">1 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm1Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">4 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm4Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">7 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm7Ctrl">
            </mat-form-field>
          </div>
          <div class="field-group" style="margin-bottom: 5px;">
            <label class="mb-2 input-label">2 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm2Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">5 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm5Ctrl">
            </mat-form-field>
            <label class="mb-2 input-label">8 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm8Ctrl">
            </mat-form-field>
          </div>
          <div class="field-group" style="margin-bottom: 5px;">
            <label class="mb-2 input-label">9 (€)</label>
            <mat-form-field style="margin-bottom: -5px;"
              [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
              appearance="outline">
              <input type="number" step="0.01" matInput formControlName="gcm9Ctrl">
            </mat-form-field>
          </div>
          <div>
            @if (invalidInput || invalidInput1 || invalidInput2 || invalidInput3 || invalidInput4 || invalidInput5 || invalidInput6 || invalidInput7 || invalidInput8 || invalidInput9) {
              <mat-hint class="error-hint"
                >{{errorMessage}}
              </mat-hint>
            }
          </div>
        </div>
      </form>
    }
    <div class="dialog-box-s" style="margin-top: -30px;">
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" color="red" textColor="white" message="{{variables.goBack}}" mat-dialog-close></app-button>
        <app-button typeBtn="primary" (click)="doAction()" message="{{variables.save}}"></app-button>
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>

</div>